import AdminOnlyWrapper from '../_core/common/components/AdminOnlyWrapper';
export default AdminOnlyWrapper;